/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Answer_5Inputs */

const en_help_center__payments_n_refunds__answer_5 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Answer_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolutely! We use industry-standard 256-bit SSL encryption. We never store your credit card details on our servers. All payment processing is handled through secure, certified payment gateways. We don't directly interact with your financial information.`)
};

/**
* | output |
* | --- |
* | "Absolutely! We use industry-standard 256-bit SSL encryption. We never store your credit card details on our servers. All payment processing is handled throug..." |
*
* @param {Help_Center__Payments_N_Refunds__Answer_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__answer_5 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Answer_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Answer_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__answer_5(inputs)
});